/**
 * @since 1.0.0
 * @author ApMod Development Team
 */

import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { ClientContextService } from './client-context.service';
import { UserService } from './user.service';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(
    private _router: Router,
    private _clientContextService: ClientContextService,
    private _logger: LoggerService,
    private _userService: UserService) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this._logger.log('route ->>> ', route.data);
    this._logger.log('clientContext ->>>', this._clientContextService.clientContext);
    const url: string = state.url;
    this._logger.log('redirect the ->', url);
    this._logger.log('route.data -->', route.data);

    // check thoroughly all the edge cases
    // if the user is already loggedIn and then login/ register/ forgot passwords like things doesnt make sense
    /*  if (route.data && route.data.isNotAuthenticated && this._clientContextService.clientContext.isUserAuthorized) {
       this._router.navigate(['/dashboard']);
       return false;
     } */

    if (route.data && route.data.authorization
      && !this._userService.hasPermission(route.data.authorization.permissions, route.data.authorization.operator)) {
      this._router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
